var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"fill-height",attrs:{"align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"12","lg":"6","md":"8","sm":"10","xl":"4"}},[_c('LoginForm')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }